module.exports = __webpack_public_path__ + "static/img/left-bg.01e13a9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/left-bg.png
// module id = WM04
// module chunks = 0